var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.info && _vm.info.id)?_c('campaignSection',{attrs:{"fields":_vm.allNames,"section":_vm.section,"no-reset":true}},[_c('LoyaltyDependencies',{attrs:{"multiplePagination":"","tabs-entity":_vm.section.tabs}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }